import { SelectedMapFilter } from './utilts';

type Legend = {
  [key in SelectedMapFilter]: {
    label: string
    success?: string
    warning?: string
    danger?: string
    none?: string
  }
}

export const mapLegend: Legend = {
  MODE: {
    label: 'Режим источника',
    success: 'Штатный режим',
    danger: 'Штормовой режим',
    none: 'Нет данных',
  },
  ENABLE: {
    label: 'Активность источника',
    success: 'Источник включен',
    danger: 'Источник выключен',
    none: 'Нет данных',
  },
  DATA_RECEIVED: {
    label: 'Статус поступления данных',
    success: 'Данные поступили в срок',
    warning: 'Часть данных не поступили в срок',
    danger: 'Данные не поступили в срок',
    none: 'Нет данных',
  },
  PHENOMENON: {
    label: 'Природные явления',
    success: 'Явления не наблюдается',
    danger: 'Наблюдается опасное явление',
    none: 'Нет данных',
  },
  METEOCODE: {
    label: '-',
  },
  COMMON_METEOCODES: {
    label: 'Метеокоды',
  },
};
